import type { Action, Location } from "history";
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

type LocationListener<S> = (location: Location<S>, action: Action) => void;

// The single place that listens to navigation (WBC3-1853). Fires for every navigation with its
// action, never on mount. On react-router v5 this is `history.listen`; it becomes the data
// router's `subscribe` once each mount moves, which keeps the same per-navigation semantics.
export function useLocationChange<S = unknown>(listener: LocationListener<S>) {
	const history = useHistory<S>();
	const listenerRef = useRef(listener);
	listenerRef.current = listener;

	useEffect(
		() => history.listen((location, action) => listenerRef.current(location, action)),
		[history]
	);
}

// For class components, which cannot call the hook.
export function LocationChangeListener({ onChange }: { onChange: LocationListener<unknown> }) {
	useLocationChange(onChange);
	return null;
}
